/** Indique si le href correspond à la page courante pour `aria-current="page"` (liens internes SPA). */
export function portalNavAriaCurrentPage(pathname: string, href: string): boolean {
  if (href === '/') {
    return pathname === '/'
  }

  return pathname === href || pathname.startsWith(`${href}/`)
}
